import * as XLSX from "xlsx-js-style";
import moment from "moment";
import store from "../store";

export const exportSurgeriesToExcel = list => {
  const tmp = list.map(e => {
    let orders = "";
    e.orders.forEach(o => {
      orders += `${o.tafnit_code} > ${o.tafnit_name}${
        o.body_side ? ", " + o.body_side : ""
      }`;
    });
    return {
      זמן: `${moment(e.end).format("LT")} - ${moment(e.start).format("LT")}`,
      מטופל: e.patient_name,
      "תעודת זהות": e.passport,
      "טל׳": e.phone,
      "גיל מטופל": e.patient_age,
      מגדר: e.gender,
      ניתוח: orders,
      חדר: e.room.value.name,
      הרדמה: e.anesthesia === "y" ? "כן" : "לא",
      "ימי אישפוז": e.hospitalizationDays || 0,
      אסיסטנט: e.assistantStatus,
      "גורם משלם": e.insurance_name,
      "השתתפות עצמית": e.insurance_fee,
      "סטטוס התחייבות": e.insurance_status_heb,
      "מספר התחייבות": e.insurance_code
    };
  });
  const ws = XLSX.utils.json_to_sheet(tmp);

  // Define column widths
  ws["!cols"] = [
    { wch: 20 }, // זמן
    { wch: 15 }, // מטופל
    { wch: 15 }, // תעודת זהות
    { wch: 15 }, // טל׳
    { wch: 10 }, // גיל מטופל
    { wch: 10 }, // מגדר
    { wch: 40 }, // ניתוח
    { wch: 15 }, // חדר
    { wch: 10 }, // הרדמה
    { wch: 15 }, // ימי אישפוז
    { wch: 15 }, // אסיסטנט
    { wch: 15 }, // גורם משלם
    { wch: 15 }, // השתתפות עצמית
    { wch: 20 }, // סטטוס התחייבות
    { wch: 15 } // מספר התחייבות
  ];

  // Apply styles to header row
  for (const key in ws) {
    if (key[0] === "A" && key.replace(/\D/g, "") === "1") {
      ws[key].s = {
        font: {
          sz: 12,
          bold: true,
          color: { rgb: "324997" }
        }
      };
    }
  }

  const wb = {
    Workbook: { Views: [{ RTL: true }] },
    Sheets: {},
    SheetNames: []
  };
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

  // Save the Excel file
  XLSX.writeFile(wb, "list_data.xlsx");
};

export const exportAppointmentsToExcel = list => {
  const tmp = list.map(e => {
    const status = store.getters["getAppBubbleStatus"](
      e.status,
      e.arrival_approval
    );
    const type = store.getters["getAppScheduledBy"](e.scheduled_by, false);
    return {
      זמן: `${moment(e.end).format("LT")} - ${moment(e.start).format("LT")}`,
      מטופל: e.patientName,
      "תעודת זהות": e.patientPassport,
      "טל׳": e.patientPhone,
      "גיל מטופל": e.patient_age,
      מגדר: e.gender,
      "סוג תור": e.appointmentName,
      "דיווח הגעה": status?.text,
      "גורם משלם": e.insurance_name,
      "השתתפות עצמית": e.insurance_fee,
      "מקור שיבוץ": type?.text,
      הגעה:
        e.arrival_approval?.includes("approved") || ""
          ? "אישר/ה הגעה"
          : "עדיין לא אושר",
      "סטטוס תשלום": e.payment_status ? "שולם" : "לא שולם"
    };
  });
  const ws = XLSX.utils.json_to_sheet(tmp);

  // Define column widths
  ws["!cols"] = [
    { wch: 20 }, // זמן
    { wch: 15 }, // מטופל
    { wch: 15 }, // תעודת זהות
    { wch: 15 }, // טל׳
    { wch: 10 }, // גיל מטופל
    { wch: 10 }, // מגדר
    { wch: 25 }, // סוג תור
    { wch: 20 }, // דיווח הגעה
    { wch: 20 }, // גורם משלם
    { wch: 10 }, // השתתפות עצמית
    { wch: 20 }, // מקור שיבוץ
    { wch: 15 }, // הגעה
    { wch: 15 } // סטטוס תשלום
  ];

  // Apply styles to header row
  for (const key in ws) {
    if (key[0] === "A" && key.replace(/\D/g, "") === "1") {
      ws[key].s = {
        font: {
          sz: 12,
          bold: true,
          color: { rgb: "324997" }
        }
      };
    }
  }

  const wb = {
    Workbook: { Views: [{ RTL: true }] },
    Sheets: {},
    SheetNames: []
  };
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

  // Save the Excel file
  XLSX.writeFile(wb, "list_data.xlsx");
};
